import { CSSProperties, useId } from "react";

type FlagIconProps = {
  lang?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

// Inline SVG language flags for the profile/language switcher.
// Replaces the raster /icons/flags/{turkish,english}.webp so the app
// stays fully SVG-based (the public/icons folder is gone).
//   preserveAspectRatio="xMidYMid slice" == object-fit: cover
//   overflow:hidden lets the caller's border-radius clip the corners.
const FlagIcon = ({ lang, className, style, title }: FlagIconProps) => {
  const id = useId();
  const code = (lang || "").toUpperCase();
  const common = {
    className,
    preserveAspectRatio: "xMidYMid slice" as const,
    style: { overflow: "hidden", ...style } as CSSProperties,
    role: "img" as const,
    "aria-label": title,
  };

  if (code === "TR") {
    return (
      <svg viewBox="0 0 30 20" {...common}>
        {title ? <title>{title}</title> : null}
        <rect width="30" height="20" fill="#E30A17" />
        <circle cx="10" cy="10" r="5" fill="#fff" />
        <circle cx="11.5" cy="10" r="4" fill="#E30A17" />
        <path
          d="M14.000,10.000 L15.797,9.416 L15.797,7.527 L16.907,9.055 L18.703,8.472 L17.593,10.000 L18.703,11.528 L16.907,10.945 L15.797,12.473 L15.797,10.584 Z"
          fill="#fff"
        />
      </svg>
    );
  }

  if (code === "EN") {
    const clipFull = `${id}-full`;
    const clipDiag = `${id}-diag`;
    return (
      <svg viewBox="0 0 60 30" {...common}>
        {title ? <title>{title}</title> : null}
        <clipPath id={clipFull}>
          <path d="M0,0 v30 h60 v-30 z" />
        </clipPath>
        <clipPath id={clipDiag}>
          <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
        </clipPath>
        <g clipPath={`url(#${clipFull})`}>
          <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
          <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
          <path
            d="M0,0 L60,30 M60,0 L0,30"
            clipPath={`url(#${clipDiag})`}
            stroke="#C8102E"
            strokeWidth="4"
          />
          <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
          <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
        </g>
      </svg>
    );
  }

  return null;
};

export default FlagIcon;
